import {Component, OnInit, ViewChild} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UserService} from '../../shared/services/user_service';
import {BankingFormComponent} from '../banking-form/banking-form.component';
import {LegalInfoComponent} from '../legal-info/legal-info.component';
import {TransferMethod} from '../../shared/types/bank';
import {Router} from '@angular/router';

@Component({
  selector: 'notd-bank-transfer',
  templateUrl: './bank-transfer.component.html',
  styleUrls: ['./bank-transfer.component.scss']
})

export class BankTransferComponent implements OnInit {
  @ViewChild('bankingComponent', {static: false}) bankingChild: BankingFormComponent;
  @ViewChild('legalInfoComponent', {static: false}) legalInfoChild: LegalInfoComponent;

  amountToTransfer: number;
  balance: number;
  amountToTransferEdited: number;
  ready;
  fee;
  currency = 'PROD';
  amountValid;
  saving;
  editingBank = false;
  bank;
  noBank;
  legalInfo;
  legalInfoForm;
  bankForm;
  refreshingLegalInfo = true;
  refreshingBank = true;
  refreshingBalance = false;
  enumTransferMethod: typeof TransferMethod = TransferMethod;

  componentMessage = {value: undefined, css: ''};

  constructor(
    public activeModal: NgbActiveModal,
    private userService: UserService,
    private modalService: NgbModal,
    private router: Router
  ) {}

  ngOnInit() {
    this.ready = true;
    this.amountValid = false;
    this.saving = false;
    this.noBank = true;
  }

  refresh() {
    this.balance = 0;
    this.amountToTransfer = 0;
    this.refreshingBalance = true;
    this.userService.getProfile(true).then(user => {
        this.refreshingBalance = false;
        if (user.funds && user.funds[this.currency]) {
          let balance: any = user.funds[this.currency];

          if (balance > 0) {
            balance = '' + user.funds[this.currency]; // Balance is stored in 1/10000 USD
            balance = parseFloat(balance.substr(0, balance.length - 2)) / 100; // We truncate value, not round it
          }
          this.balance = balance;
          this.amountToTransfer = this.balance - this.fee;
        }
      },
      err => {
        console.error('Error', err);
        this.refreshingBalance = false;
      }
    );
  }

  saveBanking() {
    const promises = [];

    this.saving = true;

    if (this.legalInfoForm.valid) {
      promises.push(this.legalInfoChild.saveLegalInfo());
    }

    if (
      (this.enumTransferMethod.ACH && this.bankForm.valid && this.bankForm.form.value.accountNumber &&
        this.bankForm.form.value.accountNumber.length > 9) ||
      (this.enumTransferMethod.IBAN && this.bankForm.valid && this.bankForm.form.value.accountNumber &&
        this.bankForm.form.value.accountNumber.length > 9) ||
      (this.enumTransferMethod.CHECK)
    ) {
      promises.push(this.bankingChild.saveBanking());
    }

    Promise.all(promises).then(() => {
        this.noBank = false;
        this.saving = false;
      },
      err => {
        console.error('Error', err);
        this.saving = false;
      }
    );
  }

  changeBank() {
    this.editingBank = !this.editingBank;
    if (this.editingBank) {
      this.noBank = false;
    } else if (!this.bank) {
      this.noBank = true;
    }
  }

  addBank() {
    this.editingBank = !this.editingBank;
  }

  priceValid(price: any) {
    this.amountValid = true;
    if (price.invalid) {
      this.amountValid = false;
    } else {
      this.amountToTransferEdited = price.float;
    }
  }

  bankingEvent(data: any) {
    if (data.form) {
      this.bankForm = data.form;
    }

    if (data.bank) {
      this.refreshingBank = false;
      this.noBank = false;
      this.userService.getBankFee(data.bank.id).then(
        resp => {
          this.bank = data.bank;
          this.fee = resp.fee / 100;
          this.refresh();
        },
        err => {
          console.error('Error', err);
        }
      );
    }

    if (data.nobank) {
      this.refreshingBank = false;
    }
  }

  legalInfoEvent(data: any) {
    this.legalInfo = data.legalInfo;
    if (data.form) {
      this.legalInfoForm = data.form;
    }

    if (data.legalInfo) {
      this.refreshingLegalInfo = false;
    }
  }

  transferMoney() {
    this.saving = true;

    const params = {
      currency: this.currency,
      amount: '' + ((this.amountToTransferEdited + this.fee) * 100).toFixed(0),
      bankId: this.bank.id
    };

    this.userService.transferMoney(params).then(() => {
        this.saving = false;
        this.componentMessage.value = 'Money has been transferred';
        this.componentMessage.css = '';
        this.refresh();
      },
      err => {
        console.log('Error', err);
        this.saving = false;
        this.componentMessage.css = 'error';
        this.componentMessage.value = 'Error';
        if (err.statusText) {
          this.componentMessage.value += ' ' + err.statusText;
        }
      }
    );
  }

  saveBankInfoForm() {
    this.saveBanking();
  }
}
